// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyADY_-dth4hGnJMpHO46fi7lpMMX3WxhpQ",
  authDomain: "leibelthedevmocks.firebaseapp.com",
  projectId: "leibelthedevmocks",
  storageBucket: "leibelthedevmocks.firebasestorage.app",
  messagingSenderId: "422012737051",
  appId: "1:422012737051:web:c27cae5d77bfc6d3d50abe",
  measurementId: "G-CT1YCLR0E5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { app, auth, analytics };

